import {formatMalariaResults} from './malaria';

export const TRAINING_MALARIA_REPORT_TYPE = 'malaria';
export const TRAINING_MALARIA_PARASITE_TERM = 'Malaria_Detected';
export const TRAINING_MALARIA_WBC_TERM = 'White_Blood_Cell';

function sameId(left, right) {
  return left !== undefined && left !== null && right !== undefined && right !== null && String(left) === String(right);
}

function annotationTermIds(annotation) {
  const terms = Array.isArray(annotation?.term) ? annotation.term : [];
  return terms.map(term => typeof term === 'object' ? term.id : term);
}

function hasTermId(annotation, termId) {
  return annotationTermIds(annotation).some(id => sameId(id, termId));
}

export function validateTrainingMalariaTerms(parasiteTerm, wbcTerm) {
  if (!parasiteTerm || parasiteTerm.name !== TRAINING_MALARIA_PARASITE_TERM) {
    return {valid: false, error: 'invalid-parasite-term'};
  }
  if (!wbcTerm || wbcTerm.name !== TRAINING_MALARIA_WBC_TERM) {
    return {valid: false, error: 'invalid-wbc-term'};
  }
  if (sameId(parasiteTerm.id, wbcTerm.id)) {
    return {valid: false, error: 'duplicate-term-id'};
  }
  return {valid: true};
}

function asDetection(annotation, type, termId) {
  if (!hasTermId(annotation, termId)) {
    return null;
  }
  const confidenceAvailable = annotation.confidence !== undefined && annotation.confidence !== null && Number.isFinite(Number(annotation.confidence));
  return {
    ...annotation,
    type,
    confidence: confidenceAvailable ? Number(annotation.confidence) : 1,
    confidenceAvailable,
    termName: type === 'parasite' ? TRAINING_MALARIA_PARASITE_TERM : TRAINING_MALARIA_WBC_TERM
  };
}

function uniqueDetections(annotations, type, termId, seenById) {
  const detections = [];
  annotations.forEach(annotation => {
    const detection = asDetection(annotation, type, termId);
    if (!detection) {
      return;
    }
    const key = String(detection.id);
    const previousType = seenById.get(key);
    if (previousType && previousType !== type) {
      throw new Error(`Annotation ${key} resolves to both malaria report roles.`);
    }
    if (!previousType) {
      seenById.set(key, type);
      detections.push(detection);
    }
  });
  return detections;
}

export function createTrainingMalariaResult({
  parasiteTerm,
  wbcTerm,
  parasiteAnnotations = [],
  wbcAnnotations = []
}) {
  const validation = validateTrainingMalariaTerms(parasiteTerm, wbcTerm);
  if (!validation.valid) {
    throw new Error(validation.error);
  }
  const seenById = new Map();
  const detections = [
    ...uniqueDetections(parasiteAnnotations, 'parasite', parasiteTerm.id, seenById),
    ...uniqueDetections(wbcAnnotations, 'wbc', wbcTerm.id, seenById)
  ];
  return {
    ...formatMalariaResults('training-malaria-report', 'Malaria report', {detections}),
    isTrainingReport: true,
    sourceTermIds: {
      parasite: parasiteTerm.id,
      wbc: wbcTerm.id
    }
  };
}
